import { InjectionToken } from '@angular/core';

export interface ConsentRoutingService {
  isConsentFlowRoute(): boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  navigateToConsentFlow(returnRoute?: string, returnQueryParams?: any): void;
}

export const CONSENT_FLOW_ROUTE = ['consent', 'flow'] as const;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const buildConsentQueryParams = (returnRoute?: string, returnQueryParams?: any) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const consentQueryParams: any = {};

  if (returnRoute) {
    consentQueryParams.returnRoute = returnRoute;
  }

  if (returnQueryParams) {
    consentQueryParams.returnQueryParams = JSON.stringify(returnQueryParams);
  }

  return consentQueryParams;
};

export const isConsentFlowUrl = (url?: string | null) => {
  const safeUrl = url ?? '';
  const normalizedUrl = safeUrl.split('?')[0];
  return normalizedUrl.startsWith('/consent/flow') || normalizedUrl.startsWith('/consent');
};

export const ConsentRoutingService = new InjectionToken<ConsentRoutingService>(
  'CONSENT_ROUTING_SERVICE'
);
